import { get_app_state } from "../../../state/store"
import { SCORE_SHORTAGE_MULTIPLIER } from "../../model/v3/constants"
import { COLOURS } from "../constants"


export function GameScore()
{
    const score = get_app_state(state => state.simulation_state.sim_state?.score)

    return <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        {score && <div className="ui_section">
            <div><b>Score</b> {Math.round(score.total_score)}</div>

            <div>Building cost: {to("neg", score.building_cost)}</div>
            <div>
                Shortage: {to("neg", score.shortage_TWh, 2)} TWh
                <span style={{ fontSize: "var(--font-small)", color: COLOURS.text_muted }}> x{SCORE_SHORTAGE_MULTIPLIER}</span>
            </div>
            <div>Excess: {to("pos", score.excess_TWh, 2)} TWh</div>
            <div>Resilience: {to("neg", score.resilience_score)}</div>
            <div>Running cost: {to("neg", score.running_cost)}</div>
        </div>}
    </div>
}
function to(neg_pos: "neg" | "pos", value: number, decimal_places = 1)
{
    let value_str = value ? value.toFixed(decimal_places) : "0"
    if (value > 0) value_str = (neg_pos === "neg" ? "-" : "+") + value_str
    return value_str
}
